module.exports = __webpack_public_path__ + "static/media/loading.4553b5b2.gif";